import React, { useContext, useMemo } from 'react';
import { Drawer, TabsProps } from 'antd';

import TaskKanbanBoard from '@totem/components/ticketing/details/tasks/kanban/taskKanbanBoard';
import TaskContext from '@totem/components/ticketing/details/tasks/taskContext';
import TaskDetails from '@totem/components/ticketing/details/tasks/taskDetails';
import TaskEntryDialog from '@totem/components/ticketing/details/tasks/taskEntryDialog';
import TasksTable from '@totem/components/ticketing/details/tasks/tasksTable';
import TicketContext from '@totem/components/ticketing/details/ticketContext';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';
import IBDIcon from '@totem/styles/Icon';
import { isNotNull } from '@totem/utilities/common';

import '../../ticketing.css';

const TasksSection = () => {
  const { ticket, action } = useContext(TicketContext);
  const { rawTasks, resources, taskAction, taskActionExtras, onTaskAction } =
    useContext(TaskContext);

  const tabItems: TabsProps['items'] = useMemo(() => {
    return [
      {
        key: 'list',
        label: 'List',
        children: <TasksTable />,
      },
      {
        key: 'kanban',
        label: 'Kanban',
        children: <TaskKanbanBoard />,
      },
    ];
  }, []);

  const getTitle = () => {
    const task = JSON.parse(taskActionExtras);

    return (
      <div style={{ fontSize: '18px', fontWeight: 700 }}>
        <IBDIcon name={task.type} style={{ marginRight: '16px' }} />
        {task.number}: {task.name}
      </div>
    );
  };

  return (
    <>
      <IBTabs defaultActiveKey="list" items={tabItems} />
      {action === 'show-task-create' &&
        isNotNull(ticket) &&
        isNotNull(ticket.ticket) && (
          <TaskEntryDialog resources={resources} tasks={rawTasks} />
        )}
      {taskAction === 'show-task-details' &&
        taskActionExtras !== '' &&
        isNotNull(ticket) &&
        isNotNull(ticket.ticket) && (
          <Drawer
            title={getTitle()}
            placement={'bottom'}
            height={'50%'}
            closable
            onClose={() => onTaskAction('', '')}
            open={taskAction === 'show-task-details'}
            key={'taskDetails'}
          >
            <TaskDetails task={JSON.parse(taskActionExtras)} />
          </Drawer>
        )}
    </>
  );
};

export default TasksSection;
